import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/app/AppLayout';
import { RequireAuth } from '@/app/RequireAuth';
import { HubPage } from '@/modules/core/hub/HubPage';
import { LoginPage } from '@/modules/core/auth/LoginPage';

// Módulo Core
import { DashPage } from '@/modules/core/dash/DashPage';
import { NotifPage } from '@/modules/core/notif/NotifPage';
import { ConfigPage } from '@/modules/core/config/ConfigPage';
import { AdminPage } from '@/modules/core/admin/AdminPage';
import { AuditPage } from '@/modules/core/audit/AuditPage';
import { OutboxPage } from '@/modules/core/outbox/OutboxPage';

// Módulo Gabinete
import { ContatosPage } from '@/modules/gab/contatos/ContatosPage';
import { LiderancasPage } from '@/modules/gab/liderancas/LiderancasPage';
import { DatasPage } from '@/modules/gab/datas/DatasPage';
import { SolicitacoesPage } from '@/modules/gab/solicitacoes/SolicitacoesPage';
import { AgendaPage } from '@/modules/gab/agenda/AgendaPage';
import { VisitasPage } from '@/modules/gab/visitas/VisitasPage';
import { AcoesPage } from '@/modules/gab/acoes/AcoesPage';
import { EmendasPage } from '@/modules/gab/emendas/EmendasPage';
import { ReguasPage } from '@/modules/gab/reguas/ReguasPage';
import { CampanhasPage } from '@/modules/gab/campanhas/CampanhasPage';

// Módulo OTO · Estratégia
import { PerfilPage } from '@/modules/oto/perfil/PerfilPage';
import { FontesPage } from '@/modules/oto/fontes/FontesPage';
import { EstrategiasPage } from '@/modules/oto/estrategias/EstrategiasPage';
import { AgentesPage } from '@/modules/oto/agentes/AgentesPage';
import { AgentePage } from '@/modules/oto/agente/AgentePage';

// Módulo Inteligência Eleitoral
import { VisaoGeralPage } from '@/modules/eleg/visao/VisaoGeralPage';
import { TerrPage } from '@/modules/eleg/terr/TerrPage';
import { ElegCandPage } from '@/modules/eleg/historico/ElegCandPage';
import { ControleVotacaoPage } from '@/modules/eleg/controle/ControleVotacaoPage';
import { MatrizPage } from '@/modules/eleg/matriz/MatrizPage';
import { ElegBnPage } from '@/modules/eleg/bn/ElegBnPage';
import { PesquisasPage } from '@/modules/eleg/pesquisas/PesquisasPage';
import { FalandoPage } from '@/modules/eleg/falando/FalandoPage';
import { AlertasPage } from '@/modules/eleg/alertas/AlertasPage';
import { IntegPage } from '@/modules/eleg/integ/IntegPage';
import { DefinirSenhaPage } from '@/modules/core/auth/DefinirSenhaPage';
import { CargosParlamentaresPage } from '@/modules/core/cargos/CargosParlamentaresPage';
import { LoginOperadorPage } from '@/modules/plataforma/LoginOperadorPage';
import { MandatosPage } from '@/modules/plataforma/MandatosPage';

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: '/login', element: <LoginPage /> },

  /* Publica por natureza: quem abre o link de definicao de senha ainda nao tem
     sessao -- e nao teria como ter, porque e justamente a senha que falta. */
  { path: '/definir-senha', element: <DefinirSenhaPage /> },

  /* Console do operador da plataforma. Fora do `RequireAuth` de mandato de
     proposito: a sessao aqui e de outra natureza, guardada separada e recusada
     pelas rotas de gabinete (ver `plataforma/sessao-de-operador.ts` na API).
     Nao aparece em menu nenhum do produto. */
  { path: '/plataforma', element: <LoginOperadorPage /> },
  { path: '/plataforma/mandatos', element: <MandatosPage /> },
  {
    path: '/hub',
    element: (
      <RequireAuth>
        <HubPage />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      // 1. Gestão
      { path: 'dashboard', element: <DashPage /> },
      { path: 'notificacoes', element: <NotifPage /> },

      // 2. Relacionamento
      { path: 'contatos', element: <ContatosPage /> },
      { path: 'liderancas', element: <LiderancasPage /> },
      { path: 'datas', element: <DatasPage /> },

      // 3. Atendimento
      { path: 'solicitacoes', element: <SolicitacoesPage /> },
      { path: 'agenda', element: <AgendaPage /> },
      { path: 'visitas', element: <VisitasPage /> },

      // 4. Atuação
      { path: 'acoes', element: <AcoesPage /> },
      { path: 'emendas', element: <EmendasPage /> },
      { path: 'reguas', element: <ReguasPage /> },

      // 5. OTO · Estratégia
      { path: 'perfil', element: <PerfilPage /> },
      { path: 'fontes', element: <FontesPage /> },
      { path: 'estrategias', element: <EstrategiasPage /> },
      { path: 'agentes', element: <AgentesPage /> },

      // 6. Inteligência Eleitoral
      { path: 'eleg', element: <VisaoGeralPage /> },
      { path: 'territorio', element: <TerrPage /> },
      { path: 'campanhas', element: <CampanhasPage /> },
      { path: 'historico', element: <ElegCandPage /> },
      { path: 'controle-votacao', element: <ControleVotacaoPage /> },
      { path: 'pesquisas', element: <PesquisasPage /> },
      { path: 'matriz', element: <MatrizPage /> },
      { path: 'brancos-nulos', element: <ElegBnPage /> },
      { path: 'falando', element: <FalandoPage /> },
      { path: 'alertas', element: <AlertasPage /> },
      { path: 'integracoes', element: <IntegPage /> },
      { path: 'agente', element: <AgentePage /> },

      // 7. Administração
      { path: 'admin', element: <AdminPage /> },
      { path: 'cargos-parlamentares', element: <CargosParlamentaresPage /> },
      { path: 'config', element: <ConfigPage /> },
      { path: 'auditoria', element: <AuditPage /> },
      { path: 'outbox', element: <OutboxPage /> },
    ],
  },
]);
